export const blockIconsTextformattingFactCheckNew = (
	<span className='material-symbols-outlined'>fact_check</span>
);
